export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const isUuid = (str) => /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(str);

export const isChromeExtensionInstalled = () => {
	if (process.env.NODE_ENV === "development") return true; // If on DEV then assume we have the extension
	if (/\bCrOS\b/.test(navigator.userAgent)) return true; // If Chrome OS
	if (document.getElementsByClassName("wonde-extension-installed").length) return true; // Else, if the Wonde Extension is t installed

	return false;
};

export const isInViewport = function (idString) {
	const bounding = document.getElementById(idString).getBoundingClientRect();

	return (
		bounding.top >= 0 &&
		bounding.left >= 0 &&
		bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
};

export const formatDate = (timestamp, format) => {
	const date = new Date(parseInt(timestamp.toString().length === 10 ? timestamp * 1000 : timestamp, 10));
	const pad = (num) => (num.toString().length < 2 ? `0${num}` : num);
	const YYYY = date.getFullYear();
	const MM = pad(date.getMonth() + 1);
	const DD = pad(date.getDate());
	const hh = pad(date.getDate());
	const mm = pad(date.getMinutes());

	format = format.replace("YYYY", YYYY);
	format = format.replace("DD", DD);
	format = format.replace("MM", MM);
	format = format.replace("hh", hh);
	format = format.replace("mm", mm);

	return format;
};

export const passwordPictures = {
	73: "+",
	27: "C",
	28: "D",
	29: "E",
	30: "F",
	31: "G",
	32: "H",
	33: "I",
	34: "J",
	35: "K",
	51: 0,
	68: "!",
	64: "$",
	63: "%",
	70: "(",
	62: ")",
	69: "*",
	71: ";",
	67: "@",
	25: "A",
	26: "B",
	36: "L",
	37: "M",
	38: "N",
	39: "O",
	40: "P",
	41: "Q",
	42: "R",
	43: "S",
	44: "T",
	45: "U",
	46: "V",
	47: "W",
	48: "X",
	49: "Y",
	50: "Z",
	65: "_",
	1: "a",
	2: "b",
	3: "c",
	4: "d",
	5: "e",
	6: "f",
	7: "g",
	8: "h",
	9: "i",
	10: "j",
	11: "k",
	12: "l",
	13: "m",
	14: "n",
	15: "o",
	16: "p",
	17: "q",
	18: "r",
	19: "s",
	20: "t",
	21: "u",
	22: "v",
	23: "w",
	24: "x",
	72: "|",
	52: 1,
	53: 2,
	54: 3,
	56: 4,
	57: 5,
	58: 6,
	59: 7,
	60: 8,
	61: 9,
};

export const copyTextToClipboard = (string) => {
	const el = document.createElement("textarea");
	el.value = string;
	el.setAttribute("readonly", "");
	el.style.position = "absolute";
	el.style.left = "-9999px";
	document.body.appendChild(el);
	el.select();
	document.execCommand("copy");
	document.body.removeChild(el);
};

export const applicationVersion = 2.42;



// WEBPACK FOOTER //
// ./src/utils/common.js